<template>
  <table class="VueTables__table table is-bordered is-fullwidth is-striped">
    <thead>
      <th v-if="activeTab === 'specifique'">
        {{ $t("paramInterne.titre_client") }}
      </th>
      <th>
        {{ $t("paramInterne.titre_nom") }}
      </th>
      <th>
        {{ $t("paramInterne.titre_description") }}
      </th>
      <th class="width-30">
        {{ $t("paramInterne.titre_valeur") }}
      </th>
    </thead>
    <tbody>
      <tr
        v-for="(param, index) in filteredParams"
        :key="index"
        class="height-60"
      >
        <td
          v-if="activeTab === 'specifique'"
          class="vertical-alignment has-text-weight-bold"
        >
          {{
            $i18n.te(param.traduction + "_client")
              ? $t(param.traduction + "_client")
              : ""
          }}
        </td>
        <td class="has-text-weight-bold vertical-alignment">
          {{ $t(param.traduction) }}
        </td>
        <td class="vertical-alignment">
          {{
            $i18n.te(param.traduction + "_description")
              ? $t(param.traduction + "_description")
              : ""
          }}
        </td>
        <td class="vertical-alignment">
          <qd-switch
            v-if="param.type === Boolean"
            v-model="param.value"
            class="mgt-5px"
          >
          </qd-switch>
          <b-input
            v-model="param.value"
            v-else
            :type="param.type ? param.type.toString() : null"
          >
          </b-input>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    params: {
      type: Array,
      required: true,
    },
    activeTab: {
      type: String,
      required: true,
    },
  },
  computed: {
    filteredParams() {
      return this.params.filter(p => p.modele === this.activeTab);
    },
  },
};
</script>
